import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "gfu-circular-score" }
const _hoisted_2 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 100 100"
}
const _hoisted_3 = ["stroke-dasharray", "stroke-dashoffset"]
const _hoisted_4 = { class: "gfu-circular-score__content" }
const _hoisted_5 = ["data-qa"]
const _hoisted_6 = { class: "gfu-circular-score__label" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("circle", {
        class: "gfu-circular-score__background-stroke",
        cx: "50%",
        cy: "50%",
        r: "45%",
        "stroke-width": "6",
        fill: "none"
      }, null, -1 /* CACHED */)),
      _createElementVNode("circle", {
        class: _normalizeClass($options.progressStrokeClass),
        transform: "rotate(-90 50 50)",
        cx: "50%",
        cy: "50%",
        r: "45%",
        "stroke-dasharray": $options.circumference,
        "stroke-width": "6",
        "stroke-dashoffset": $options.strokeDashOffset,
        "stroke-linecap": "round",
        fill: "none",
        style: {
                    transition: 'stroke-dashoffset 1s ease-out',
                }
      }, null, 10 /* CLASS, PROPS */, _hoisted_3)
    ])),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "gfu-circular-score__value",
        "data-qa": $props.dataQa
      }, _toDisplayString($props.score) + "%", 9 /* TEXT, PROPS */, _hoisted_5),
      _createElementVNode("div", _hoisted_6, [
        _createTextVNode(_toDisplayString($props.label) + " ", 1 /* TEXT */),
        _createVNode(_component_tooltip, {
          text: $props.tooltipLabel,
          "icon-name": "circle-info"
        }, null, 8 /* PROPS */, ["text"])
      ])
    ])
  ]))
}